var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "left_svg__left",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1096 14.4596C11.3635 14.2058 11.3635 13.7942 11.1096 13.5404L5.56924 8L11.1096 2.45962C11.3635 2.20578 11.3635 1.79422 11.1096 1.54038C10.8558 1.28654 10.4442 1.28654 10.1904 1.54038L4.19038 7.54038C3.93654 7.79422 3.93654 8.20578 4.19038 8.45962L10.1904 14.4596C10.4442 14.7135 10.8558 14.7135 11.1096 14.4596Z",
    fill: "currentColor"
  })));
};
export default SvgLeft;